<div class="clare-date-picker">
    <label class="input-label">{{ label }}</label>
    <mat-form-field [appearance]="appearance">
        <input
            matInput
            [matDatepicker]="picker"
            [min]="minString"
            [max]="maxString"
            [ngModel]="dateTime"
            (dateChange)="onDateChange($event)"
            readonly
            (focus)="picker.open()"
            (click)="picker.open()"
        />
        <mat-datepicker-toggle class="toggle-date" matPrefix [for]="picker">
            <mat-icon matDatepickerToggleIcon svgIcon="schedule-calendar"></mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker touchUI disabled="false"></mat-datepicker>
    </mat-form-field>
</div>
